'use client'
import React from 'react'
import Link from 'next/link'

const BuildProfileEmptyState = () => (
  <>
    <div className="no-disc-text">
      Your profile is incomplete{' '}
      <span style={{ fontStyle: 'normal', margin: '8px' }}>
        <Link
          href={'/app/onboarding?step=welcome'}
          className={'CE action-button destructive-button small'}
        >
          Build my personality profile
        </Link>
      </span>
    </div>
  </>
)

export default BuildProfileEmptyState
